export default {
  title: 'Mes démarches',
  minarmSteps: {
    first: {
      secondParagrapheWaiting: '&#8987; Nous vérifions la disponibilité du déménageur et revenons vers vous sous 24 à 48h maximum. Vous recevrez une notification par email dès que celle-ci sera validée.',
      thirdParagraphe: 'Une fois votre offre pré-réservée, vous aurez la possibilité de télécharger le devis correspondant pour pouvoir le transmettre @:base.minarm_organism_au et constituer votre dossier de déménagement en ligne.',
      cardFlex: {
        titleWaiting: '<b>Nous vérifions la disponibilité du déménageur.</b><br>Vous recevrez une notification par email dès que celle-ci sera validée afin de pouvoir constituer votre dossier de déménagement sur Démarches Simplifiées.',
      },
    },
    second: {
      title: 'Je constitue mon dossier',
      firstParagraphe: 'Félicitations, vous avez pré-réservé l\'offre nécessaire pour constituer votre dossier de déménagement. Il ne reste plus qu\'à constituer votre dossier auprès @:base.minarm_organism_du pour finaliser la réservation. Pour cela, voici la démarche à suivre :',
      panel: {
        title: 'Comment constituer mon dossier ?',
        firstParagraphe: 'Téléchargez le devis pré-réservé en cliquant sur le bouton ci-dessous.',
        secondParagraphe: 'Téléchargez les conditions générales du service PFMD en cliquant sur le bouton ci-dessous.',
        thirdParagraphe: {
          before: 'Constituez votre dossier via le formulaire en ligne mis à disposition par le MINARM (accessible au choix sur INTERNET ou sur le réseau INTRADEF) grâce aux boutons ci-dessous. Vous devrez joindre au formulaire le devis,',
          beforeGN: 'Constituez votre dossier via le formulaire en ligne mis à disposition par la GN (accessible au choix sur INTERNET ou sur le réseau INTRADEF) grâce aux boutons ci-dessous. Vous devrez joindre au formulaire le devis,',
          linkText: 'les conditions générales du service PFMD',
          after: 'complétées et signées ainsi que votre ordre de mutation. Votre numéro de dossier PFMD, qui vous sera également demandé, est le suivant : {numClient}.',
        },
        fourthParagraphe: 'Lorsque @:base.minarm_organism_le validera votre dossier, vous recevrez un email de notre part vous informant de la validation. Vous n\'aurez plus qu\'à retourner sur votre espace client pour signer votre devis électroniquement. Vous pourrez alors rentrer en contact avec le déménageur choisi et votre offre sera définitivement réservée.<br> <i> ATTENTION : à compter de la pré-réservation, vous avez <strong>{nbDays}</strong> pour transmettre votre dossier et valider l\'offre choisie. Sans retour de votre part au bout de ces {nbDays}, la pré-réservation pourra être annulée. La validité de l\'offre du déménageur ne sera alors plus garantie.',
        downloadQuote: 'Télécharger le devis',
        downloadCgu: 'Télécharger les CGV',
        createMyFile: 'Constituer mon dossier (INTRADEF)',
        createMyFileOnline: 'Constituer mon dossier (INTERNET)',
        cguLink: `${import.meta.env.VITE_APP_PUBLIC_ASSETS_URL}docs/cgv_pfmd.pdf`,
        createMyFileLink: 'https://demarches-simplifiees.intradef.gouv.fr/commencer/pfmd-metropole-partie1',
        createMyFileLinkInter: 'https://demarches-simplifiees.intradef.gouv.fr/commencer/pfmd-hm-partie1',
        createMyFileLinkOnline: 'https://demarches-simplifiees.defense.gouv.fr/commencer/pfmd-metropole-partie1',
        createMyFileLinkOnlineInter: 'https://demarches-simplifiees.defense.gouv.fr/commencer/pfmd-hm-partie1',
        createMyFileLinkGN: 'https://demarches-simplifiees.intradef.gouv.fr/commencer/TODO-gn-pfmd-metropole-partie1',
        createMyFileLinkInterGN: 'https://demarches-simplifiees.intradef.gouv.fr/commencer/TODO-gn-pfmd-hm-partie1',
        createMyFileLinkOnlineGN: 'https://demarches-simplifiees.defense.gouv.fr/commencer/TODO-gn-pfmd-metropole-partie1',
        createMyFileLinkOnlineInterGN: 'https://demarches-simplifiees.defense.gouv.fr/commencer/TODO-gn-pfmd-hm-partie1',
      },
      cardFlex: {
        icon: ['fas', 'hands-clapping'],
        title: 'Félicitations, vous avez pré-réservé l\'offre nécessaire pour constituer votre dossier de déménagement. Si cela n\'est pas déjà fait, il ne reste plus qu\'à <b>constituer votre dossier</b> auprès @:{\'base.minarm_organism_du\'}.',
        button: 'Constituer mon dossier',
        buttonLinkPath: '/procedures',
      },
    },
    third: {
      firstParagraphe: 'Suite à l\'envoi de votre dossier, l\'offre de <b>{name} à {price}</b> a été validée par @:base.minarm_organism_le !<br>Dernière étape pour finaliser la réservation de votre déménagement, signer votre devis !',
      cardFlex: {
        title: '<b>La prise en charge de votre dossier a été validée par @:{\'base.minarm_organism_le\'}.</b><br>Finalisez votre réservation en signant électroniquement votre devis.',
      },
    },
    fourth: {
      secondTitle: 'Après le déménagement',
      secondTitleSub: 'Une fois le déménagement réalisé, voici la suite des démarches :',
      panel: {
        title: 'Liquider mon dossier',
        firstParagraphe: 'Pour liquider votre dossier de déménagement auprès @:{\'base.minarm_organism_du\'}, il vous faut :',
        firstList: '<span style="font-weight:bold">Le devis signé</span> (voir la section « Mes documents » ci après).',
        secondList: '<span style="font-weight:bold">La lettre de voiture</span> du déménagement complétée et signée (voir la section « Mes documents » ci après).',
        thirdList: 'Votre ordre de mutation (si non transmis dans le formulaire 1ère partie).',
        fourthList: 'Et tous documents liés à un changement de situation familiale (acte de mariage, naissance…) pour confirmation de vos droits.',
        secondParagraphe: 'Une fois ces documents réunis, il vous faudra les transmettre au plus vite @:base.minarm_organism_au via le formulaire mis à disposition dans le cadre du dispositif PFMD, accessible via INTRADEF ou via INTERNET à votre convenance en cliquant sur l\' un des boutons ci-dessous.',
        secondParagrapheGN: 'Une fois ces documents réunis, il vous faudra les transmettre au plus vite @:base.minarm_organism_au via le formulaire mis à disposition dans le cadre du dispositif PFMD, accessible via INTRADEF ou via INTERNET à votre convenance en cliquant sur l\' un des boutons ci-dessous.',
        closeFile: 'Liquider mon dossier (INTRADEF)',
        closeFileLink: 'https://demarches-simplifiees.intradef.gouv.fr/commencer/pfmd-metropole-partie2',
        closeFileLinkInter: 'https://demarches-simplifiees.intradef.gouv.fr/commencer/pfmd-hm-partie2',
        closeFileOnline: 'Liquider mon dossier (INTERNET)',
        closeFileLinkOnline: 'https://demarches-simplifiees.defense.gouv.fr/commencer/pfmd-metropole-partie2',
        closeFileLinkOnlineInter: 'https://demarches-simplifiees.defense.gouv.fr/commencer/pfmd-hm-partie2',
        closeFileLinkGN: 'https://demarches-simplifiees.intradef.gouv.fr/commencer/TODO-gn-pfmd-metropole-partie2',
        closeFileLinkInterGN: 'https://demarches-simplifiees.intradef.gouv.fr/commencer/TODO-gn-pfmd-hm-partie2',
        closeFileLinkOnlineGN: 'https://demarches-simplifiees.defense.gouv.fr/commencer/TODO-gn-pfmd-metropole-partie2',
        closeFileLinkOnlineInterGN: 'https://demarches-simplifiees.defense.gouv.fr/commencer/TODO-gn-pfmd-hm-partie2',
      },
      documents: {
        title: 'Vos documents',
        firstParagraphe: 'Voici les documents disponibles pour constituer votre dossier :',
        signedQuote: 'Devis signé',
        facture: 'Facture',
        waybill: 'Lettre de voiture',
        empty: 'Aucun document n\'est disponible pour le moment.',
      },
    },
  },
  courtageSteps: {
    first: {
      cardFlex: {
        title: 'Retrouvez ici <b>les devis reçus des déménageurs professionnels</b> sélectionnés spécifiquement pour la prise en charge de votre déménagement *',
      },
    },
    third: {
      cardFlex: {
        icon: ['fas', 'hands-clapping'],
        title: '<b>Votre choix a bien été enregistré.</b>',
        button: 'Plus d\'infos',
        buttonLinkPath: '/quote',
      },
    },
    fourth: {
      cardFlex: {
        icon: ['fas', 'hands-clapping'],
        title: '<b>Votre choix a bien été enregistré.</b>',
        button: 'Plus d\'infos',
        buttonLinkPath: '/quote',
      },
    },
  },
  cardFlex: {
    button: 'Plus d\'infos',
    iconOffersDisabled: ['far', 'clock'],
    titleOffersDisabled: '<b>Nous effectuons une mise à jour sur votre dossier.</b><br>Vous pouvez contacter votre expert pour plus d\'informations.',
  },
  steps: {
    title: 'Vos démarches',
    first: {
      title: 'Je pré-réserve une offre',
      titleIndividual: 'Je choisis un déménageur',
      firstParagrapheNoOffers: 'Vos devis ne sont pas encore disponibles pour le moment.',
      firstParagraphe: 'Vous retrouverez sur la page « COMPARATIF » notre sélection des meilleures offres reçues pour votre déménagement.',
      firstParagrapheWaiting: 'Votre demande de pré-réservation a bien été enregistrée.',
      firstParagrapheIndividual: 'Vous trouverez sur la page « COMPARATIF » notre sélection des meilleures sociétés de déménagement pour votre projet.',
      secondParagraphe: 'Sélectionnez une offre pour constituer votre dossier de déménagement en cliquant sur le bouton « PRÉ-RÉSERVER » correspondant. La pré-réservation est valable pendant {nbDays}.',
      secondParagrapheIndividual: 'Sélectionnez une offre en cliquant sur le bouton « CHOISIR ».',
      secondParagrapheWaiting: '&#8987; Nous vérifions la disponibilité du déménageur, et transmettons le devis à votre employeur pour validation. Vous recevrez une notification par email dès que la prise en charge de votre déménagement sera validée.',
      secondParagrapheWaitingIndividual: '&#8987; Nous vérifions la disponibilité du déménageur et revenons vers vous sous 24 à 48h maximum. Vous recevrez une notification par email dès que celle-ci sera validée.',
      toSeeComparator: 'Voir comparatif',
      cardFlex: {
        icon: ['fas', 'lightbulb-on'],
        title: 'Retrouvez ici <b>les devis reçus des déménageurs professionnels</b> sélectionnés spécifiquement pour la prise en charge de votre déménagement.',
        titleIndividual: 'Retrouvez ici <b>les devis reçus des déménageurs professionnels</b> sélectionnés spécifiquement pour la prise en charge de votre déménagement *',
        iconWaiting: ['far', 'clock'],
        titleWaiting: '<b>Nous vérifions la disponibilité du déménageur.</b><br>Vous recevrez une notification par email dès que celle-ci sera validée.',
      },
    },
    second: {
      title: 'Votre entreprise étudie l\'offre',
      titleIndividual: 'Nous vérifions la disponibilité',
      cardFlex: {
        icon: ['far', 'clock'],
        title: '<b>Nous attendons la validation de l\'offre par votre enteprise.</b><br>Vous recevrez une notification par email dès que celle-ci sera validée.',
        titleIndividual: '<b>Nous vérifions la disponibilité du déménageur.</b><br>Vous recevrez une notification par email dès que celle-ci sera validée.',
      },
      firstParagraphe: 'Nous avons transmis l\'offre retenue à votre employeur pour validation de la prise en charge de votre déménagement. Une fois que la prise en charge par votre entreprise sera confirmée, il ne vous restera plus qu\'à signer le devis en ligne pour finaliser la réservation.',
      firstParagrapheIndividual: 'Une fois la disponibilité validée, il ne vous restera plus qu\'à signer le devis en ligne pour finaliser la réservation.',
    },
    third: {
      title: 'Je valide une offre',
      titleIndividual: 'Je signe mon devis',
      cardFlex: {
        icon: ['fas', 'hands-clapping'],
        title: '<b>La prise en charge de votre dossier a été validée par votre entreprise.</b><br>Finalisez votre réservation et signez votre devis en cliquant sur le bouton &laquo; Signer &raquo;.',
        titleIndividual: '<b>La disponibilité du déménageur est confirmée.</b><br>Finalisez votre réservation en signant électroniquement votre devis.',
        button: 'Signer le devis',
        buttonLinkPath: '/comparator/{offerId}#{signPath}',
      },
      firstParagraphe: 'Suite à l\'analyse de votre dossier, l\'offre de <b>{name}</b> a été validée par votre entreprise !',
      firstParagrapheIndividual: 'Après vérification des disponibilités de votre déménageur, votre choix a été accepté.<br>Dernière étape : signer votre contrat.<br><br>Pour rappel, vous disposez d\'un délai de {nbDays} pour signer votre contrat.',
      secondParagraphe: 'Cliquez sur le bouton « {btnName} » ci dessous pour finaliser la réservation du déménageur.',
      sign: 'Signer mon contrat',
      signIndividual: 'Signer mon contrat',
    },
    fourth: {
      title: 'Votre déménagement',
      cardFlex: {
        title: '&#127881; <b>Votre réservation a bien été enregistrée.</b>',
      },
      firstParagraphe: 'Votre devis a bien été signé !',
      firstParagrapheIndividual: 'Votre devis a bien été signé.',
      secondParagraphe: 'Pour organiser votre déménagement, le déménageur va prendre contact avec vous pour :',
      list: {
        first: 'Bloquer les dates du déménagement',
        second: 'Planifier la fourniture de vos cartons (si incluse)',
        third: 'Confirmer les conditions d\'accès et de stationnement au chargement et à la livraison (si connue)',
      },
      thirdParagraphe: 'Enfin, il vous faut également remplir la déclaration de valeur et nous la renvoyer signée (voir ci dessous).',
      declaration: {
        title: 'Déclaration de valeur',
        titleIndividual: 'La déclaration de valeur : votre garantie indispensable',
        receivedDeclaration: 'Nous avons bien reçu votre déclaration de valeur',
        declarationLabel: 'Télécharger',
        sentDeclaration: 'Votre déclaration de valeur a bien été enregistrée',
        modificationDeclaration: 'Si vous souhaitez la modifier, renvoyez-nous le document mis à jour via le bouton « Charger un fichier » ci-dessous.',
        texteDeclaration: {
          first: 'Pour assurer vos biens pour le déménagement, il est impératif de remplir une déclaration de valeur et de nous la retourner signée au plus tard 7 jours avant la date de chargement. Pour cela, téléchargez le modèle via le lien ci-dessous.',
          second: 'Une fois le document rempli et signé, renvoyez-le nous via le bouton « Charger un fichier » ci-dessous.',
        },
        declarationExample: 'Télécharger le modèle de déclaration de valeur à remplir',
        declarationRedirection: 'Faire sa déclaration en ligne',
      },
      disput: {
        title: 'Déclarer un litige',
        titleIndividual: 'Nous restons en contact jusqu\'à la réalisation de votre demenagement',
        firstParagraphe: 'Vous rencontrez un problème sur votre déménagement ?',
        firstParagrapheIndividual: 'Que faire en cas de litige ?',
        secondParagraphe: 'Nous sommes là pour vous accompagner et régler les éventuels dysfonctionnements. Pour cela, vous pouvez ouvrir un dossier litige en cliquant sur le bouton ci-dessous. Un de nos experts vous recontactera dans les meilleurs délais.',
        mailTo: "mailto:contact{'@'}nextories.com?subject=Litige%20d%C3%A9m%C3%A9nagement%20-%20dossier%202018040898&amp;cc=julien.bardet{'@'}nextories.com",
        button: 'Déclarer un litige',
      },
    },
    reSign: {
      cardFlex: {
        title: '🔔 <b>Votre dossier a été mis à jour</b>. Cliquez sur le bouton &laquo; Signer &raquo; pour signer votre devis mis à jour.',
      },
    },
    preBookedOffers: {
      firstParagraphe: 'Votre pré-réservation a expiré ! La validité de l\'offre du déménageur n\'est pas garantie, contactez votre conseiller pour vous en assurer.',
      secondParagraphe: 'Votre pré-réservation est encore valide pendant <strong>{remainingDays} jour(s)</strong>.',
      thirdParagraphe: 'Voici l\'offre que vous avez pré-réservée : ',
      thirdParagrapheIndividual: 'Nous vérifions la disponibilité de votre déménageur.<br>Attention, votre déménagement n\'est pas encore réservé : vous recevrez un email (sous 24 à 48h maximum) dès lors que le contrat sera prêt à être signé.',
      forthParagraphe: 'Nous vérifions la disponibilité du déménageur. Dès que la pré-réservation sera validée, nous vous alerterons par email (sous 24h maximum).',
      forthParagrapheIndividual: 'Voici l\'offre que vous avez sélectionnée :',
    },
    bookedOffer: {
      preReservationUntil: 'Pré-réservée jusqu\'au',
    },
  },
};
